module.exports = __webpack_public_path__ + "static/media/honeycomb-logo-full-dark.12981723.png";